import ArticleLayout from "@/components/feature/ArticleLayout";

export default function HoodiesArticle() {
  return <ArticleLayout slug="pandabuy-sheet-hoodies-guide" />;
}